export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.admin.invite-user': 'Invite User',         // 新增
  'menu.admin.cdn-management': 'CDN Management',   // 新增
  'menu.games': 'Mini Games',
  'menu.statistics': 'Statistics',
  'menu.game-management': 'Game Management',
  'menu.game-management.review-management': 'Review Management',      // 新增
  'menu.game-management.game-list-management': 'Game List Management',// 新增
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Registration Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitoring',
  'menu.dashboard.workplace': 'Workspace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form Page',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form (Transfer Info)',
  'menu.form.step-form.confirm': 'Step Form (Confirmation)',
  'menu.form.step-form.result': 'Step Form (Completed)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List Page',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Standard List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List (Articles)',
  'menu.list.search-list.projects': 'Search List (Projects)',
  'menu.list.search-list.applications': 'Search List (Apps)',
  'menu.profile': 'Profile Page',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result Page',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Failure',
  'menu.exception': 'Error Page',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger Error',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Map',
  'menu.editor.koni': 'Topology Editor',
  'menu.sdk-user': 'SDK User Management',
  'menu.projects': 'Projects',
  'menu.project-detail': 'Project Detail',
  'menu.credentials': 'Credentials',
  'menu.game-selection': 'Game Selection',
  'menu.api-docs': 'API Documentation',
  'menu.api-docs-detail': 'API Doc Detail',
};